import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocWarning(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.429 99.625C17.117 99.625 12 94.508 12 88.196h57.143c0 6.312 5.117 11.429 11.428 11.429H23.43Z"
        fill="#E2E8F0"
      />
      <path
        d="M80.571 99.625C86.883 99.625 92 94.508 92 88.196V19.625H34.857v68.571c0 6.312-5.117 11.429-11.428 11.429H80.57Z"
        fill="#F1F5F9"
      />
      <path
        d="M35.657 88.196c0 6.754-5.475 12.229-12.228 12.229a.8.8 0 1 1 0-1.6c5.87 0 10.628-4.759 10.628-10.629a.8.8 0 1 1 1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M83.429 81.682a.8.8 0 0 1 0 1.6h-40a.8.8 0 0 1 0-1.6h40Zm0-5.714a.8.8 0 1 1 0 1.6h-40a.8.8 0 1 1 0-1.6h40Zm0-5.715a.8.8 0 0 1 0 1.6h-40a.8.8 0 0 1 0-1.6h40Zm0-5.714a.8.8 0 0 1 0 1.6h-40a.8.8 0 1 1 0-1.6h40Zm-17.143-5.714a.8.8 0 0 1 0 1.6H43.429a.8.8 0 0 1 0-1.6h22.857Zm-1.429-5.715a.8.8 0 0 1 0 1.6H43.43a.8.8 0 1 1 0-1.6h21.428Zm2.858-5.713a.8.8 0 0 1 0 1.6H43.429a.8.8 0 0 1 0-1.6h24.286Zm3.81-5.715a.8.8 0 0 1 0 1.6H43.428a.8.8 0 0 1 0-1.6h28.095Zm3.808-5.714a.8.8 0 1 1 0 1.6H43.429a.8.8 0 1 1 0-1.6h31.904Z"
        fill="#B3C0D0"
      />
      <path
        d="M85.19 29.276 70.818 52.368c-1.998 3.21.383 7.306 4.246 7.306h28.752c3.864 0 6.245-4.097 4.246-7.307l-14.38-23.092c-1.93-3.1-6.562-3.1-8.492.001Z"
        fill="#FC0"
      />
      <path
        d="M91.266 52.22a1.822 1.822 0 0 1-1.825 1.819 1.822 1.822 0 0 1-1.825-1.818c0-1.004.817-1.818 1.825-1.818s1.825.814 1.825 1.818ZM90.781 47.12l.483-9.886a1.83 1.83 0 0 0-1.823-1.923 1.83 1.83 0 0 0-1.823 1.923l.483 9.885a1.345 1.345 0 0 0 1.34 1.282c.716 0 1.305-.564 1.34-1.282Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocWarning)
